/* SYNCED from shotbook-landing/src/components/ui/Logo.tsx — не править руками, запускать npm run sync:ds */
import { cx } from '@/lib/cx';
import { ApertureMark } from './ApertureMark';
import { VisuallyHidden } from './VisuallyHidden';
import styles from './Logo.module.css';

/**
 * Знак ShotBook. Буквы набраны шрифтом заголовков текущей локали,
 * знак-диафрагма занимает место буквы «O» и красится акцентом.
 *
 * Буквы скрыты от скринридеров и заменены цельным словом — иначе
 * они читаются как «SH ТBOOK» с дырой на месте знака.
 */
export function Logo({ small = false, className }: { small?: boolean; className?: string }) {
  return (
    <span className={cx(styles.logo, small && styles.small, className)}>
      <span aria-hidden="true" className={styles.word}>
        SH
      </span>
      <ApertureMark className={styles.mark} />
      <span aria-hidden="true" className={styles.word}>
        TBOOK
      </span>
      <VisuallyHidden>ShotBook</VisuallyHidden>
    </span>
  );
}
